// confetti-js ships only a browser build, which assigns window.ConfettiGenerator and exports nothing.
import 'confetti-js';

export default window.ConfettiGenerator;
